export default __webpack_public_path__ + "static/media/routerpng.ba6d175e.png";